module.exports = __webpack_public_path__ + "img/fable.f126ad0d.png";